<template>
    <div>
      <p class="message" v-html="$t('discount.voucher.reusabilityError.info')"></p>
      <ul>
        <li class="error-message" v-for="error in errors" :key="error.source">
          {{ getErrorMessage(error) }}
        </li>
      </ul>
    </div>
</template>
<style scoped>
  @import '../../../assets/css/button-style.css';

  .message {
    margin: 0;
  }
  </style>
<script>
import { mapState } from 'vuex';
import i18nProvider from '@/lang/i18nProvider';

export default {
  name: 'reusability-error',
  computed: {
    ...mapState({
      errors: (state) => state.voucher.voucherErrors,
    }),
  },
  methods: {
    getErrorMessage(error) {
      // Currently we expect the second argument to represent days until next issuing
      const match = error.args[1].match(/\d+/);
      const daysUntilNextIssuing = match ? parseInt(match[0], 10) : null;
      return i18nProvider.t(`discount.voucher.reusabilityError.messages.${error.source}.${error.code}`, { daysUntilNextIssuing });
    },
  },
};
</script>
